import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    flagcreate: 1,
    previousRoute: null,
    navCollapsed: false,
    false2:false,
  },
  getters: {
    getFlagcreate: state => state.flagcreate,
    previousRoute: state => state.previousRoute,
    getNavCollapsed: state => state.navCollapsed
  },
  mutations: {
    setFlagcreate(state, value) {
      state.flagcreate = value
    },
    setPreviousRoute(state, route) {
      state.previousRoute = route
    },
    toggleNavCollapsed(state) {
      state.navCollapsed = !state.navCollapsed
    },
    setNavCollapsed(state, value) {
      state.navCollapsed = value
    },
    // 添加flag mutation来修改false属性
    flag(state, value) {
      state.false2 = value
    }
  },
  actions: {
  },
  modules: {
  },
  plugins: [
    createPersistedState({
      paths: ['flagcreate', 'previousRoute', 'navCollapsed','false2']
    })
  ]
})
